const BODY_CLASS_NAME = 'onboarding-tour--active';
export const addOnboardingTourBodyClass = () => {
  document.body.classList.add(BODY_CLASS_NAME);
};
export const removeOnboardingTourBodyClass = () => {
  document.body.classList.remove(BODY_CLASS_NAME);
};